'use client';

/* -------------------------------------------------------------------------- */
/*                                Dependencies                                */
/* -------------------------------------------------------------------------- */

// Lib dependencies
import { useTranslation } from 'react-i18next';

// UI lib components
import { Box, Group, Button } from '@mantine/core';

// Types
import { ConfirmBarProps } from './types';

// Styles
import * as classes from './styles/index.css';
import { palette } from '../../colors';

/* -------------------------------------------------------------------------- */
/*                                  Component                                 */
/* -------------------------------------------------------------------------- */

function ConfirmBar({
  onConfirm = () => {},
  onCancel = () => {},
  disabled = false,
  saving = false,
  labelProps,
  color,
  ...props
}: ConfirmBarProps) {
  /* ********************************** HOOKS ********************************* */

  // Localization
  const { t } = useTranslation('Common');

  // Style

  /* ******************************** RENDERING ******************************* */
  return (
    <Box className={classes.confirmBar} {...props}>
      <Group h="100%" justify="flex-end" align="center">
        <Button
          onClick={() => onCancel()}
          variant="subtle"
          color="blackroomGray"
          c={palette.blackroomDarkGray2}
        >
          {labelProps?.cancel ?? t('prompts.cancel')}
        </Button>
        <Button
          onClick={() => onConfirm()}
          disabled={disabled}
          variant="filled"
          loading={saving}
          color={color}
        >
          {labelProps?.confirm ?? t('prompts.confirm')}
        </Button>
      </Group>
    </Box>
  );
}

export default ConfirmBar;
